"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MergeStatus = void 0;
var MergeStatus;
(function (MergeStatus) {
    MergeStatus["ACTIVE"] = "ACTIVE";
    MergeStatus["INACTIVE"] = "INACTIVE";
})(MergeStatus || (exports.MergeStatus = MergeStatus = {}));
//# sourceMappingURL=merge.js.map